var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "h-screen w-full flex" }, [
    _c(
      "div",
      {
        staticClass:
          "flex items-center justify-center w-0 md:w-2/3 imageContainer",
      },
      [_c("CompanyLogo", { staticClass: "w-1/2" })],
      1
    ),
    _c(
      "div",
      { staticClass: "w-full md:w-1/3 min-w-68 md:min-w-100" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }